import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import AutoComplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import orderHelpers from '../../helpers/orders'
import ZeroInventoryTable from './ZeroInventoryTable';

function ZeroInventory(props) {

    const [zeroedOutInventory, setZeroedOutInventory] = useState([]);
    const [skuList, setSkuList] = useState([]);
    const [sku, setSku] = useState(null);

    useEffect(() => {
        getZeroedSkus();
        getDropshipSkus();
    }, [])

    const getZeroedSkus = async() => {
        props.setLoading(true);
        let temp = await orderHelpers.getZeroedOutInventory(props.company, props.token);
        setZeroedOutInventory(temp.items);
        props.setLoading(false);
    }

    const addZeroedInventory = async() => {
        const trimmed = (sku ?? '').trim();
        if (!trimmed) return;
        props.setLoading(true);
        try {
            const date_added = new Date().toISOString();
            const temp = await orderHelpers.setZeroedOutInventory(props.company, props.token, trimmed, date_added);
            if (Array.isArray(temp?.items)) {
                setZeroedOutInventory(temp.items);
            } 
            else if (temp?.item) {
                setZeroedOutInventory(prev => {
                    if (prev.some(row => row.sku === temp.item.sku)) return prev;
                    return [...prev, temp.item];
                });
            } 
            else {
                setZeroedOutInventory(prev => {
                    if (prev.some(row => row.sku === trimmed)) return prev;
                    return [...prev, { sku: trimmed, date_added }];
                });
            }
            setSku('')
        } catch (err) {
            console.error(err);
        } finally {
            props.setLoading(false);
        }
    };

    const getDropshipSkus = async () => {
        props.setLoading(true);
        try {
            const dropshipSkusResponse = await orderHelpers.getDropshipItems(props.company, props.token);
            const dropshipSkus = dropshipSkusResponse.items;
            const mappedSkus = dropshipSkus.map(value => ({ value: value, name: value}));
            setSkuList(mappedSkus);
        }
        catch(err) {
            console.log(err);
        }
        props.setLoading(false);
    }

    const handleDelete = async(sku) => {
        setZeroedOutInventory(prev =>
            prev.filter(item => item.sku !== sku)
        );
        await orderHelpers.deleteZeroedOutInventory(props.company, props.token, sku);
    }

    const sendInventory = async() => {
        props.setLoading(true);
        let selRows = ['Amazon Direct', 'chewy dropship', 'Walmart Marketplace', 'Target', 'Kohls', 'Wayfair', 'Shopify'];
        for(let vendor of selRows) {
            console.log("Sending Inventory For ", vendor);
            if (vendor === "Amazon Direct") {
                try {
                    await orderHelpers.sendAmazonDirectInventory(props.token);
                } catch (error) {
                    console.log(error);
                    props.toast.error(`Failed to send Amazon Direct inventory, please contact a developer`);
                }
            } else if (vendor === "Shopify") {
                try {
                    await orderHelpers.sendShopifyInventory(props.token);
                } catch (error) {
                    console.log(error);
                    props.toast.error(`Failed to send Shopify inventory, please contact a developer`);
                }
            } else {
                await orderHelpers.vendorRequest(vendor, "inventory", props.company, props.token);
            }
            console.log("Done!");
        }
        setTimeout(() => { props.setLoading(false)}, 5000);
    }

    const filter = createFilterOptions();


return (
    <Box
        display="flex"
        flexDirection="column"
        className={props.isMobile ? 'mobile-top' : 'desktop-top'}
    >
        <Box
        className={props.isMobile ? 'mobile-box' : 'desktop-box'}
        sx={{ mb: 2 }}
        >
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems="center"
            sx={{ mt: { xs: 4, sm: 8 } }} 
        >
            <TextField
                name="sku"
                value={sku}
                label="Sku to Add"
                onChange={(e) => setSku(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && addZeroedInventory()}
                sx={{ width: { xs: '100%', sm: 400 } }}
            />
            <Button
            sx={{
                height: 48,
                minWidth: 120,
                fontWeight: 'bold',
            }}
            variant = 'contained'
            onClick={addZeroedInventory}
            size="large"
            disabled={!sku?.trim()}
            >
            Add
            </Button>
            <Button
            sx={{
                height: 48,
                minWidth: 120,
                fontWeight: 'bold',
            }}
            variant = 'contained'
            onClick={sendInventory}
            size="large"
            >
            Send Inventory
            </Button>
        </Stack>
        </Box>

        <Box className={props.isMobile ? 'mobile-box' : 'desktop-box'}>
        <h1>Zeroed Out Inventory</h1>
        <ZeroInventoryTable
            {...props}
            zeroedOutInventory={zeroedOutInventory}
            handleDelete={handleDelete}
        />
        </Box>
    </Box>
    );
}


export default ZeroInventory;